export default __webpack_public_path__ + "static/media/whatzon-black.6372fd93.svg";